export interface Organization {
	id: number;
	name: string;
	address: Address;
	role: string;
	roleDescription: string;
	status: string;
	statusDescription: string;
	administrator: Administrator;
	suppliers?: Suppliers[];
	suppliersString: string;
	diffusions: DiffusionResponse[];
	personMembers: User[];
	visibilityGroups: VisibilityGroupsResponse[];
	city: string;
	countryCode: string;
	countryCodeDescription: string;
}

interface Address {
	city: string;
	countryCode: string;
	countryCodeDescription: string;
}
interface DiffusionResponse {
	serviceCode: string;
	label: string;
}

interface OrganizationVisibility {
	name: string;
	isPayer: number;
	isShipTo: number;
	isSoldTo: number;
}

interface Administrator {
	id: number;
	firstName: string;
	lastName: string;
}
interface Suppliers {
	id: number;
	name: string;
}

interface User {
	firstName: string;
	lastName: string;
}
interface VisibilityGroupsResponse {
	organizationVisibility: OrganizationVisibility[];
}

export const organizationInnerFields = <const> [
	'personMembers.user',
	'diffusions',
	'diffusions.service',
	'visibilityGroups.visibilityGroupBocClients',
	'visibilityGroups.visibilityGroupBocClients.bocClient',
	'supplierGroupMembers.supplierGroup'
];
